// Lets the user choose a photo and returns it as a small JPEG data URL,
// so it can be stored with the item in the local database.
const MAX_WIDTH = 480;
const MAX_HEIGHT = 360;

function resize(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("The file could not be read"));
    reader.onload = () => {
      const image = new window.Image();
      image.onerror = () => reject(new Error("The file is not an image"));
      image.onload = () => {
        const scale = Math.min(
          1,
          MAX_WIDTH / image.width,
          MAX_HEIGHT / image.height,
        );
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(image.width * scale);
        canvas.height = Math.round(image.height * scale);
        const context = canvas.getContext("2d");
        context.fillStyle = "#fff";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      };
      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export function pickImage() {
  return new Promise((resolve, reject) => {
    if (typeof document === "undefined") {
      reject(new Error("Choosing a photo is not supported on this device"));
      return;
    }
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = () => {
      const file = input.files && input.files[0];
      if (!file) {
        resolve(null);
        return;
      }
      resize(file).then(resolve, reject);
    };
    input.click();
  });
}
